import { render, staticRenderFns } from "./TTBBelumInvoice.vue?vue&type=template&id=d0684f6a&scoped=true&"
import script from "./TTBBelumInvoice.vue?vue&type=script&lang=js&"
export * from "./TTBBelumInvoice.vue?vue&type=script&lang=js&"
import style0 from "./TTBBelumInvoice.vue?vue&type=style&index=0&id=d0684f6a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0684f6a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VProgressLinear,VRow})
